import { render, staticRenderFns } from "./AlternativeFormView.vue?vue&type=template&id=d2aa378c&"
import script from "./AlternativeFormView.vue?vue&type=script&lang=js&"
export * from "./AlternativeFormView.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeFormView.vue?vue&type=style&index=0&id=d2aa378c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports